import { render, staticRenderFns } from "./VisitReportList.vue?vue&type=template&id=180d77de"
import script from "./VisitReportList.vue?vue&type=script&lang=js"
export * from "./VisitReportList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports